import { render } from "./group.principal.vue?vue&type=template&id=0375b9d0"
import script from "./group.principal.vue?vue&type=script&lang=js"
export * from "./group.principal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__